import router from '@/router'
import cmd from '../../common/Command'
import qestionService from '../../service/QestionService'

const QuestionModule = {
  namespaced: true,
  state: {
    questions: [],
    selectedQuestions: [],
    treeData: [],    
    currentId: "",
    currentIndex: 0,
    okCount: 0,
    ngTitle: [],
    question: "",
    answer: "",
    lastClickTime: 0
  },
  mutations: {
    initData (state) {
      state.currentIndex = 0
      state.okCount = 0
      state.ngTitle = []
      state.selectedQuestions = []
    },
    questions (state, value) {
      state.questions = value 
    },
    setTreeData (state, value) {
      state.treeData = value 
    },
    selectedQuestions (state, value) {
      state.selectedQuestions = value 
    },
    currentIndex (state, value) {
      state.currentIndex = value 
    },
    okCount (state, value) {
      state.okCount = value 
    },

    currentId (state, value) {
      state.currentId = value
      state.question = state.selectedQuestions[state.currentIndex]["question"]
      state.answer = state.selectedQuestions[state.currentIndex]["answer"]
    },
    setWrongRows (state, value) {
      state.wrongRows = value 
    },
  },
  actions: {    
    //ツリー用データ作成
    search ({ commit, state, rootState }, callbackToView) {

      function callback(rows){

        //質問データ作成
        var list = qestionService.getListData(rows)
        commit('questions', list)

        //ツリー構造に変換
        var treeData = qestionService.getTreeData(list)
        commit('setTreeData', treeData)

        //View側からのコールバック実行
        callbackToView()
      }
      cmd.getData("question", callback)
      
    },
    
    //前ページ
    prevAction ({ commit, state, rootState }) {
      router.go(-1)
    },
    //問題ページ
    nextAction ({ commit, state, rootState }) {

      //選択されたノード
      var selectedId = [];
      var selectedElms = $('#treeList1').jstree("get_selected", true);
      $.each(selectedElms, function(idx, row) {
        if (row.id.substr(0, 1) == "q") {

          var nodes = row.original.nodes;          
          $.each(nodes, function(idx2, row2) {
            selectedId.push(row2.id);
          })
        }
      })

      if (selectedId.length == 0) {
        //alert("問題を選択してください")
        $("#errorModal").remodal().open()
        return
      }

      var selectedArray = []
      $.each(selectedId, function(idx, row){
        $.each(state.questions, function(idx2, row2){
          if (row == row2.id) {
            selectedArray.push(row2)
            return false
          }
        })
      })

      //シャッフル
      for(var i = selectedArray.length - 1; i > 0; i--){
        var r = Math.floor(Math.random() * (i + 1));
        var tmp = selectedArray[i];
        selectedArray[i] = selectedArray[r];
        selectedArray[r] = tmp;
      }

      //選択した問題
      commit('selectedQuestions', selectedArray)   

      //最初の問題をセット
      commit('currentId', selectedArray[state.currentIndex]["id"])   

      //テスト開始
      router.push('questionDetail')
    },
    //回答
    showAnswer ({ commit, state, rootState }) {

      router.push('questionAnswer')

    },
    //回答
    showNext ({ commit, state, rootState }, value) {     

      //連続クリック防止
      var ms = (new Date()).getTime()
      if (ms - state.lastClickTime < 500) {
        return
      } else {
        state.lastClickTime = ms
      }

      if (value == 1) {
        //正解を増やす
        state.okCount++
      } else {
        //不正解のタイトル
        state.ngTitle.push(state.selectedQuestions[state.currentIndex])
      }

      //カウントを増やす
      state.currentIndex++

      //最終チェック
      if (state.currentIndex == state.selectedQuestions.length) {

        //パーフェクトの場合
        if (state.okCount == state.selectedQuestions.length) {
          router.push('questionResultPerfect')
        } else {
          router.push('questionResult')
        }
        
      } else {

        //次の問題をセット
        commit('currentId', state.selectedQuestions[state.currentIndex]["id"])   
        router.push('questionDetail')
      }

    }    
  },
  getters: {
        
    treeData (state, getters, rootState) {
      return state.treeData
    },
    question (state, getters, rootState) {
      return state.question
    },
    answer (state, getters, rootState) {
      return state.answer
    },
    
    currentIndex (state, getters, rootState) {
      return state.currentIndex + 1
    },
    totalCount (state, getters, rootState) {
      return state.selectedQuestions.length
    },
    ngTitle (state, getters, rootState) {
      return state.ngTitle
    },
    isFinished (state, getters, rootState) {

      //既に達している場合（ブラウザの戻るで再度回答された場合の対応）
      if (state.currentIndex == state.selectedQuestions.length) {
        //パーフェクトの場合
        if (state.okCount == state.selectedQuestions.length) {
          return 'questionResultPerfect'
        } else {
          return 'questionResult'
        }        
      } else {
        return ""
      }
    }

  }
}

export default QuestionModule



// WEBPACK FOOTER //
// ./src/store/modules/QuestionModule.js